import { motion } from 'framer-motion';
import { HORECA } from '@/constants/testIds';
import LutfiyeLogo from './LutfiyeSignature';

const STORY_IMG =
  'https://images.pexels.com/photos/9629615/pexels-photo-9629615.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export default function Story() {
  return (
    <section
      id="hikayemiz"
      data-testid={HORECA.storySection}
      className="relative paper-cream text-[#1F1F1F] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start relative">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-80px' }}
          variants={fadeUp}
          className="lg:col-span-5 order-2 lg:order-1"
        >
          <div className="relative">
            <img
              src={STORY_IMG}
              alt="Küre Dağları — Amasra ormanları"
              className="w-full h-auto object-cover aspect-[4/5]"
              loading="lazy"
            />
            {/* Menşe rozeti — sol üst */}
            <div className="absolute top-6 left-6 bg-[#FBF7EE] text-[#1F1F1F] px-4 py-3 dark-frame">
              <div className="eyebrow text-[#B03A2E] mb-1">Menşe</div>
              <div className="font-display text-lg leading-tight">Amasra</div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-80px' }}
          variants={fadeUp}
          className="lg:col-span-7 order-1 lg:order-2"
        >
          <span className="eyebrow text-[#B03A2E] block mb-4">Hikayemiz</span>

          <div className="mb-6">
            <LutfiyeLogo
              width="w-40 md:w-52 lg:w-64"
              height="h-14 md:h-16 lg:h-20"
              color="text-[#1F1F1F]"
            />
            <div className="eyebrow text-[#5A5145] mt-3">Doğadan sofraya</div>
          </div>

          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight mb-6 max-w-xl font-light">
            Küre Dağları&apos;ndan tek tek toplanan
            <span className="italic text-[#5D2A47]"> meyvelerle </span>
            başlayan bir hikaye.
          </h2>

          <div className="space-y-5 text-[#5A5145] text-base md:text-lg leading-relaxed font-body font-light max-w-xl">
            <p>
              Meyvelerimizi Karadeniz&apos;in bakir doğasında —
              <b className="text-[#1F1F1F]"> Bartın, Amasra ve Ulus </b>
              ormanlarında yetişen ağaçlardan topluyoruz. Yerel üreticilerimizle
              birlikte, doğaya zarar vermeden, geleneksel yöntemlerle hasat
              ediyoruz.
            </p>
            <p>
              Ürünlerimizi geleneksel usulle, hiçbir katkı maddesi,
              renklendirici veya aroma kullanmadan üretiyoruz. Şekerimiz de
              meyveden.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
